export * from './tabela-alteracao-cadastral.component';
